<template>
  <div id="home" class="n2-inicio" ref="raiz">
    <!-- Mismo orden y mismos interruptores que la portada de siempre (panel: Inicio) -->
    <N2Portada />
    <N2Notario />
    <N2Servicios />
    <N2Blog />
    <N2Llamada />
    <N2Testimonios />
    <N2Galeria />
    <N2Faq />
    <N2Contacto />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAparicion } from '../../composables/useNotaria2'
import N2Portada from './N2Portada.vue'
import N2Notario from './N2Notario.vue'
import N2Servicios from './N2Servicios.vue'
import N2Blog from './N2Blog.vue'
import N2Llamada from './N2Llamada.vue'
import N2Testimonios from './N2Testimonios.vue'
import N2Galeria from './N2Galeria.vue'
import N2Faq from './N2Faq.vue'
import N2Contacto from './N2Contacto.vue'

const raiz = ref(null)
useAparicion(raiz)
</script>
